// @owners { team: patients }
import { createSelector } from 'reselect';
import getLoading from '~shared/features/ui/selectors/getLoading';
import { type ReduxStateShared } from '~shared/types';

const getUpdateQuantityLoading: (arg0: ReduxStateShared) => boolean = createSelector(
  getLoading,
  (loading) => loading?.updateQuantityLoading,
);

export default getUpdateQuantityLoading;
